/** @format */

import React, { useState, useEffect } from "react";
import { pageLoad } from "../../utils/GTMDataLayer";
import { connect } from "react-redux";
import Spinner from "../Spinner/Spinner";
import { logger } from "@goldenbird1/ui-logger-library";

function ShippingFAQforwholesalebuyers(props) {
  const [htmlContent, setHtmlContent] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    pageLoad("shipping faq","other pages");
  },[]);

  useEffect(() => {
    let buyerId = props.userProfile && props.userProfile?.userProfile?.profileId ? props.userProfile.userProfile.profileId : null;
    let url = process.env.NEXT_PUBLIC_REACT_APP_CONTENT_URL + "/content/ShippingFAQ";
    fetch(
      url,
      {
        method: "GET",
        headers: {
          "content-type": "application/json",
          Authorization: "Bearer " + process.env.NEXT_PUBLIC_ANONYMOUS_TOKEN,
        },
      }
    )
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else {
          throw res.statusText || "Content not found";
        }
      })
      .then((res) => {
        setHtmlContent(res.body);
        setLoading(false);
      })
      .catch((error) => {
        // message.error(error)
        logger("error", "Error from useEffect method ShippingFAQforwholesalebuyers: " + url + ": buyerId =>  "+buyerId+ ': error => ' +error, process.env.NEXT_PUBLIC_LOGGER_URL);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return <Spinner />;
  }

  return (
    <React.Fragment>
      <div dangerouslySetInnerHTML={{ __html: htmlContent }}></div>
    </React.Fragment>
  );
}

const mapStateToProps = (state) => {
  return {
    userProfile: state.userProfile
  };
};

export default connect(mapStateToProps, null)(ShippingFAQforwholesalebuyers);
